import React, { Component } from "react";
import Header from "../header/index";
import ProjectDetail from "../header/projectDetail";
import Footer from "../footer/index";
import CalMoney from "../footer/calMoney";
import Grid from "material-ui/Grid";
import "./index.scss";
import CardSummary from "./cardSummary";
import CardSetting from "./cardSetting";
import CardDetail from "./cardDetail";
import Spinner from "../spinner/index";
import ScrollUp from "react-scroll-up";
import Tooltip from "material-ui/Tooltip";
import Button from "material-ui/Button";

import { observer, inject } from "mobx-react";
import Warning from "../footer/warning";

import { withStyles } from "material-ui/styles";

const styles = theme => ({
  fab: {
    margin: theme.spacing.unit * 2
  },
  absolute: {
    position: "absolute",
    bottom: theme.spacing.unit * 5,
    right: theme.spacing.unit * 3,
    height: 65,
    width: 65,
    minWidth: 65,
    borderRadius: "50%",
    backgroundColor: "#ffffff",
    boxShadow: "0px 1px 1px 1px rgba(103,112,94,0.5)"
  },
  absolute2: {
      position: "absolute",
      bottom: theme.spacing.unit * 0.25,
      right: theme.spacing.unit * 1,
      height: 55,
      width: 55,
      minWidth: 55,
      borderRadius: "50%",
      backgroundColor: "#ffffff",
      boxShadow: "0px 1px 1px 1px rgba(103,112,94,0.5)"
  }
});

@inject("summaryDataStore")
@observer
class Summary extends Component {
  componentDidMount() {}

  render() {
    const { loading } = this.props.summaryDataStore;
    const { classes } = this.props;
    return (
      <div>
        {loading ? (
          <Spinner isLoading={loading} />
        ) : (
          <div className="summary">
            <Header />
            <ProjectDetail />
            <div className="container">
              <Grid container className="containerGrid" spacing={0}>
                <Grid md={1} lg={2} />
                <Grid xs={12} sm={6} md={5} lg={4}>
                  <div class="gridSummary-Detail">
                    <Grid xs={12} sm={12} md={12}>
                      <CardSummary />
                    </Grid>
                    <Grid xs={12} sm={12} md={12}>
                      <CardDetail />
                    </Grid>
                  </div>
                </Grid>
                <Grid xs={12} sm={6} md={5} lg={4}>
                  <div class="gridSetting">
                    <Grid xs={12} sm={12} md={12}>
                      <CardSetting />
                    </Grid>
                  </div>
                </Grid>
                <Grid md={1} lg={2} />
              </Grid>
            </div>
            <CalMoney />
            <Warning />
            <Footer />
            <div id="web_">
              <ScrollUp showUnder={650}>
                <Button variant="fab" className={classes.absolute}>
                  <img src="assets/arrow_up.svg" style={{ width: 65 }} />
                </Button>
              </ScrollUp>
            </div>
            <div id="mobile_">
              <ScrollUp showUnder={650} id="mobile_">
                <Button variant="fab" className={classes.absolute2} >
                  <img src="assets/arrow_up.svg" style={{ width: 55 }} />
                </Button>
              </ScrollUp>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(Summary);



// WEBPACK FOOTER //
// ./src/components/summary/index.js